import controller from './bulkUpload.controller';
import template from './bulkUpload.pug';

const BulkUploadComponent = {
  template,
  controller,
};

export default BulkUploadComponent;



// WEBPACK FOOTER //
// ./client/app/cases/bulkUpload/bulkUpload.component.js